import { JointShapes } from '../nodes/markup'

export const LinkLabelAttrs = {
  width: 120,
  height: 30,
  fontSize: 12
}

export const minLabelSize = { width: 10, height: 30 }

/**
 * Returns the attributes for a link.
 * @returns {joint.dia.Link.Attributes} The attributes for the link.
 */
export const getLinkAttrs = () => ({
  type: JointShapes.Node,
  attrs: {
    root: { cursor: 'pointer' },
    line: {
      connection: true,
      targetMarker: {
        type: 'path',
        d: 'M 10 -5 0 0 10 5 z',
        fill: 'context-stroke',
        stroke: 'context-stroke'
      }
    },
    wrapper: { connection: true }
  },
  labels: [],
  markup: getLinkMarkup(),
  defaultLabel: getLabelsAttrs(),
  labelSize: minLabelSize, // set link label size that are taken into account when autolayout
  router: { name: 'normal', args: { padding: 0 } },
  connector: { name: "curve" }
})

/**
 * Returns the markup for a link.
 * @returns {joint.dia.MarkupNodeJSON[]} The markup for the link.
 */
const getLinkMarkup = () => [
  {
    tagName: 'path',
    selector: 'line',
    className: 'node-link-line'
  },
  {
    tagName: 'path',
    selector: 'wrapper',
    className: 'node-link-wrapper'
  }
]

/**
 * Returns the attributes for the labels on a link.
 * @returns {joint.dia.Link.Label} The attributes for the labels on the link.
 */
const getLabelsAttrs = () => ({
  // applied to all labels on this link:
  markup: [
    {
      tagName: 'rect',
      selector: 'body',
      className: 'joint-link-label-body'
    },
    {
      tagName: 'text',
      selector: 'label',
      className: 'joint-link-label-text'
    },
    // --- CHIP RECTANGLE ---
    {
      tagName: 'rect',
      selector: 'chip',
      className: 'joint-link-label-chip'
    },
    // --- CHIP TEXT ---
    {
      tagName: 'text',
      selector: 'chipText',
      className: 'joint-link-label-chip-text'
    }
  ],
  attrs: {
    body: {
      ref: 'label', // reference to label to set wrapper width depending on text width
      refWidth: '100%',
      refHeight: '100%',
      refWidth2: 30, // add wrapper x padding
      refHeight2: 15, // add wrapper y padding
      refX: -15, // move the wrapper half the padding width to left
      refY: -7.5 // move the wrapper half the padding width to top
    },
    label: {
      textWrap: {
        width: LinkLabelAttrs.width, // max width before ellipsis
        height: LinkLabelAttrs.height, // max height
        ellipsis: true,
        fontSize: LinkLabelAttrs.fontSize,
        fontFamily: 'Roboto'
      },
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      fontSize: LinkLabelAttrs.fontSize,
      cursor: 'text'
    },
    // --- CHIP RECTANGLE ATTRS ---
    chip: {
      ref: 'body', // position relative to label body
      refX: -44, // adjust as needed for padding
      refY: -5,
      width: 28,
      height: 16,
      rx: 8, // rounded corners
      fill: '#f5f5f5',
      stroke: '#212121',
      strokeWidth: 1,
      display: 'visible' // set to 'none' to hide if needed
    },
    // --- CHIP TEXT ATTRS ---
    chipText: {
      ref: 'chip',
      refX: 14, // center of chip width
      refY: 8, // center of chip height
      textAnchor: 'middle',
      textVerticalAnchor: 'middle',
      fontSize: 10,
      fill: '#212121',
      text: '', // <-- Set this dynamically when creating the label
      display: 'visible',
      fontFamily: 'Roboto',
      fontWeight: 'bold'
    }
  }
})
